import { type TranslationTree } from '@/i18n/types';

export const messages = {
  columns: {
    offer: 'Oferta',
    action: 'Cupom e botões',
    period: 'Período pedido',
    status: 'Status',
    campaign: 'Campanha',
  },
  hint: {
    changes_requested: 'Ajuste pedido · veja a nota da revisão',
    rejected: 'Recusada · veja o motivo',
  },
  noPeriod: 'Sem preferência',
  pagination: '{{from}}–{{to}} de {{count}}',
  paginationAria: {
    first: 'Primeira página',
    last: 'Última página',
    next: 'Próxima página',
    previous: 'Página anterior',
  },
} satisfies TranslationTree;
